import React, { useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import OverlaySpinner from 'core/ui/OverlaySpinner';
import ContactSellerButton from './ContactSellerButton';

const ContactSellerModal = loadable(() => import(
	'./ContactSellerModal'
), {
	fallback: <OverlaySpinner />
});

const ContactSeller = ({
	isLoggedIn = false,
	isOpen,
	setModalOpen,
	className = '',
	label = 'Contact Seller',
	notLoggedLabel = 'Sign in to contact the seller',
	contactIcon,
	size = 'lg',
	element = 'button',
	triggerLogin,
	fullWidth,
	themeType,
	...formProps
}) => {
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const modalVisible = isOpen || modalIsOpen;

	return (
		<>
			{modalVisible && (
				<ContactSellerModal
					isOpen
					setModalOpen={setModalOpen || setModalIsOpen}
					isLoggedIn={isLoggedIn}
					{...formProps}
				/>
			)}
			<ContactSellerButton
				openModal={setModalOpen || setModalIsOpen}
				isLoggedIn={isLoggedIn}
				className={className}
				label={label}
				contactIcon={contactIcon}
				size={size}
				element={element}
				fullWidth={fullWidth}
				triggerLogin={triggerLogin}
				notLoggedLabel={notLoggedLabel}
				themeType={themeType}
			/>
		</>
	);
};

ContactSeller.propTypes = {
	className: PropTypes.string,
	contactIcon: PropTypes.string,
	element: PropTypes.string,
	formProps: PropTypes.object,
	fullWidth: PropTypes.bool,
	isLoggedIn: PropTypes.bool,
	isOpen: PropTypes.bool,
	label: PropTypes.string,
	notLoggedLabel: PropTypes.string,
	openModal: PropTypes.func,
	setModalOpen: PropTypes.func,
	size: PropTypes.string,
	triggerLogin: PropTypes.func,
	themeType: PropTypes.string,
};

ContactSeller.defaultProps = {
	themeType: 'positive',
	triggerLogin: () => null,
};

export default ContactSeller;
